import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://supportchat.flekstore.com/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const chatService = {
  async getSessions() {
    const response = await api.get('/chat/sessions');
    return response.data;
  },

  async createSession(data: any) {
    const response = await api.post('/chat/sessions', data);
    return response.data;
  },

  async getMessages(sessionId: number) {
    const response = await api.get('/chat/sessions/' + sessionId + '/messages');
    return response.data;
  },

  async sendMessage(sessionId: number, content: string) {
    const response = await api.post('/chat/sessions/' + sessionId + '/messages', {
      content,
      message_type: 'text'
    });
    return response.data;
  }
};
